import React from "react";
import CV from "../../assets/cv.pdf";
import i18n from "../../languages/i18n";


const CTA = ({title1, title2}) => {
  return (
    <div className="cta">
      <a href={CV} download className={i18n.language=="ar"?"btn arabicText":"btn"}>
        {title1}
      </a>
      <a href="#contact" className={i18n.language=="en"?"btn btn-primary":"btn btn-primary arabicText"}>
        {title2}
      </a>
    </div>
  );
};

export default CTA;
